import React, { Component, PropTypes } from "react";
// import ReactHighcharts from 'react-highcharts';

import { NitroLoading, NitroText } from "nitro-components";

import Highcharts from "highcharts";
import styled from "styled-components";

import RHC from "react-highcharts";

import dashboardTheme
	from "../../../../components/charts/highcharts-themes/smpl";
import {
	getColour
} from "../../../../components/charts/highcharts-themes/helper";

const ReactHighcharts = RHC.withHighcharts(Highcharts);

let chart;
let leftLegend = [];
let rightLegend = [];

const Container = styled.div`
	display: block;
	width: 100%;
	display: flex;
	flex-direction: row;
	background: ${props => props.theme.color.white};
	height: 250px;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`;

const ChartContainer = styled.div`
	width: 240px;
	position: relative;


`;

const LegendContainer = styled.div`
	display: flex;
	flex-direction: row;
`;

const LegendItem = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	margin: 0 20px;
	cursor: pointer;
`;

const LegendName = styled.div`
	color: ${props => props.color};
`;

const NotificationItem = styled.div`
	background:#FF632D;
	color: #fff;
	border-radius: 100px;
	padding: 3px 5px;
	font-size: 10px;
	margin-top: 15px;
`;

const LeftLegend = styled.div``;

const RightLegend = styled.div``;

class ReportSemiDonutView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			leftLegend: [],
			rightLegend: []
		};
	}

	componentDidMount(prevProps) {
		const chartInstance = this.refs.chart.getChart();
		chartInstance.reflow = () => {};
	}

	componentWillMount() {
		const colors = getColour(this.props.data.length);
		this.props.data.map((item, i) => {
			if (i % 2 === 0) {
				leftLegend.push({
					name: item.name,
					notification: item.notification,
					value: item.y,
					color: colors[i]
				});
			} else {
				rightLegend.push({
					name: item.name,
					notification: item.notification,
					value: item.y,
					color: colors[i]
				});
			}
		});

		this.setState({
			leftLegend: leftLegend,
			rightLegend: rightLegend
		});
	}

	componentWillUnmount() {
		leftLegend = [];
		rightLegend = [];
	}

	getLegend = data => {
		const self = this;
		return (
			<LegendContainer>
				{data.map((item, i) => {
					return (
						<LegendItem
							onClick={() =>
								self.props.fetchReportDetail({
									FactRecordKeys: item.FactRecordKeys,
									Category: item.name
								})}
						>
							<NitroText size="60" variant="base1">
								{item.value}
							</NitroText>
							<LegendName color={item.color}>
								<NitroText>{item.name}</NitroText>
							</LegendName>
							{item.notification &&
								<NotificationItem>
									{`${item.notification} new`}
								</NotificationItem>}

						</LegendItem>
					);
				})}
			</LegendContainer>
		);
	};

	render() {
		const { data, name, error, size } = this.props;
		let total = 0;
		data.map((item, i) => {
			total = total + item.y;
		});

		if (data) {
			const chartConfig = {
				chart: {
					type: "pie",
					margin: 0,
					spacing: 0,
					height: 200
				},
				title: {
					text: `${total} total`,
					align: "center",
					verticalAlign: "middle",
					y: 80
				},
				yAxis: {
					title: {
						text: ""
					}
				},
				plotOptions: {
					pie: {
						slicedOffset: 0,
						size: "100%",
						dataLabels: {
							enabled: true,
							distance: -50,
							style: {
								fontWeight: "bold",
								color: "white"
							}
						},
						startAngle: -90,
						endAngle: 90,
						center: ["50%", "75%"]
					}
				},
				tooltip: {
					formatter: function() {
						return (
							"<b>" + this.point.name + "</b>: " + this.y + " %"
						);
					}
				},
				credits: {
					enabled: false
				},
				exporting: { enabled: false },

				series: [
					{
						type: "pie",
						name: "",
						innerSize: "50%",
						data: this.props.data,
						dataLabels: {
							enabled: false
						}
					}
				]
			};

			const { id } = chartConfig;
			Highcharts.theme = dashboardTheme;
			const newTheme = {
				...dashboardTheme,
				colors: getColour(data.length)
			};
			Highcharts.setOptions(newTheme);

			return (
				<Container>
					<LeftLegend>
						{this.getLegend(this.state.leftLegend)}
					</LeftLegend>
					<ChartContainer>
						<ReactHighcharts
							ref="chart"
							config={chartConfig}
							domProps={{ id }}
						/>
					</ChartContainer>
					<RightLegend>
						{this.getLegend(this.state.rightLegend)}
					</RightLegend>
				</Container>
			);
		} else {
			return <NitroLoading center thickness={2} size={24} />;
		}
	}
}

ReportSemiDonutView.propTypes = {
	data: PropTypes.array,
	size: PropTypes.number,
	name: PropTypes.string,
	fetchReportDetail: PropTypes.func,
	error: PropTypes.bool // TODO .isRequired
};

export default ReportSemiDonutView;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/reports/ReportSemiDonutView.js